import { optionTitle_mobile } from './MobileDeviceOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const MobileDeviceOption: LazyOption = createLazyOption(
    {
        key: 'mobileDevice',
        titleStringKey: optionTitle_mobile,
        hideTitleInFullOptions: true,
        searchTermsStringKey: optionTitle_mobile,
        isHidden: () => {
            return !isFeatureEnabled('auth-mobileDevice') || IsShadowMailboxUser();
        },
        allowedOptionKeys: ['MobileDevice'],
    },
    lazyFullModule,
    m => m.default
);
export default MobileDeviceOption;
